export enum GTMEventCategory {
  Affordability = 'Affordability',
  BookVisitModalForm = 'BookVisitModalForm',
  BuyerInterestFlow = 'BuyerInterestFlow',
  GeoFilterModalInCityPage = 'ListingsFilterArea',
  ListingDetail = 'ListingDetail',
  ListingsPage = 'ListingsPage',
  LockedPriorityDetail = 'LockedPriorityDetail',
  MainSearchFlow = 'MainSearchFlow',
  PriorityCard = 'PriorityCard',
  PriorityCardNotLogged = 'PriorityCardNotLogged',
  PriorityCarousel = 'PriorityCarousel',
  PriorityDetail = 'PriorityDetail',
  PriorityInfoBanner = 'PriorityInfoBanner',
  PriorityTab = 'PriorityTab',
  PriorityVisitModalForm = 'PriorityVisitModalForm',
  RelatedAdsBanner = 'RelatedAdsBanner',
  SimilarPropertiesCarousel = 'SimilarPropertiesCarousel',
  SuggestedPage = 'SuggestedPage',
}
